(function () {
  // Footer node refs are resolved LAZILY (not at a single init()) because the
  // deep-link auto-open paths in script-index-filters.js / script-index-product.js
  // fire on DOMContentLoaded BEFORE this section's script registers its own
  // listener — so __footerToModal must already exist (and find the footer) by the
  // time those run, or the footer is never moved into the modal and stays hidden
  // behind the display:none'd index sections. Defining the public API at IIFE
  // top-level (synchronously) guarantees it.
  var footer = null;
  var homeParent = null;
  var homeNextSibling = null;
  var applying = false;

  function ensureFooter() {
    if (footer && footer.isConnected) return footer;
    var found = document.querySelector('.footer-wrapper');
    if (found) {
      footer = found;
      // Capture the home slot the FIRST time we see the footer, before any move,
      // so __footerToHome can put it back exactly where index-footer rendered it.
      if (!homeParent) {
        homeParent = footer.parentNode;
        homeNextSibling = footer.nextSibling;
      }
    }
    return footer;
  }

  function update() {
    if (applying) return;
    var f = ensureFooter();
    if (!f) return;
    // Detached mid-move (modalInner.innerHTML cleared on rebuild/close) — skip;
    // the re-attach that follows fires the observer and we re-measure then.
    if (!f.isConnected) return;

    // NOTE: do NOT arm `applying` here. It is armed ONLY in the state-flipped
    // branch below. Setting it unconditionally at the top latched the guard
    // forever on the FIRST unchanged decision (e.g. the initial pre-layout
    // measurement reads tall → shouldPin=false, equal to the default unpinned
    // class → "unchanged" → guard never released), which then swallowed every
    // later resize and left short pages stuck UNPINNED under the grid.

    // Measure the footer's NATURAL in-flow top = the real height of everything
    // above it. The footer packs directly after the content (no margin-top:auto),
    // so this is NOT inflated by the body's min-height:100svh the way
    // scrollHeight is. offsetTop is only meaningful in the UNPINNED state.
    var wasPinned = f.classList.contains('footer-pinned');
    if (wasPinned) f.classList.remove('footer-pinned');
    var contentAboveFooter = f.offsetTop; // forces a sync layout read
    var shouldPin = contentAboveFooter <= window.innerHeight;
    f.classList.toggle('footer-pinned', shouldPin);

    // Re-entry guard, but ONLY for the frame where we actually FLIPPED the pin
    // state. Pinning/unpinning moves the footer in/out of flow and changes body
    // height, which spawns a self-induced ResizeObserver callback we must
    // swallow (else infinite toggle loop). When the decision is UNCHANGED the
    // remove+re-add nets zero body-height change and spawns no RO callback — so
    // we leave the guard open. Closing it unconditionally (the old behavior)
    // also swallowed a *legit* co-occurring resize — e.g. the index sections
    // being restored to display in showSections(), or images finishing load —
    // which left the footer stuck pinned over a now-tall grid until the next
    // manual scroll. (Bugs P1/P2/P3.)
    if (shouldPin !== wasPinned) {
      applying = true;
      requestAnimationFrame(function () { applying = false; });
    }
  }

  // Public re-measure. Callers that restore content height OUT of band with the
  // ResizeObserver (footer re-homed after a collection modal closes, or the
  // collection grid re-shown after a PDP closes) invoke this so the pin state is
  // recomputed against the now-final layout instead of a stale measurement.
  window.__footerUpdate = update;

  // --- Collection modal hand-off -------------------------------------------
  // MOVE the one real footer into the modal as the last child of
  // #collection-modal-inner so it sits AFTER the collection grid in flow;
  // update() pins it ONLY when the collection is shorter than the viewport.
  window.__footerToModal = function (modalInner) {
    var f = ensureFooter();
    if (!f || !modalInner) return;
    modalInner.appendChild(f);
    update();
  };

  window.__footerToHome = function () {
    var f = ensureFooter();
    if (!f) return;
    // Put it back exactly where index-footer rendered it.
    if (homeNextSibling && homeNextSibling.parentNode === homeParent) {
      homeParent.insertBefore(f, homeNextSibling);
    } else if (homeParent) {
      homeParent.appendChild(f);
    }
    update();
  };

  function init() {
    if (!ensureFooter()) return;
    update();

    window.addEventListener('resize', update);
    window.addEventListener('load', update);

    // Re-evaluate when content above the footer changes height
    // (e.g., lazy-loaded products, modal open/close).
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(update);
      ro.observe(document.body);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
